/* eslint-disable @typescript-eslint/no-explicit-any */
import './_youtube-video.scss';

export class YoutubePlayer {
  //
  // Private members
  private readonly player: Element;
  private readonly playButton: Element;
  private readonly overlay: Element;
  private readonly videoId: string;
  private youtubePlayer: any;
  //
  // Static stuff is used to for api callback
  private static apiIsLoaded: boolean;
  private static callbackQueue: Array<{ (): void }>;
  private static readonly apiUrl = 'https://www.youtube.com/iframe_api';

  constructor(element: Element) {
    const player = element.querySelector('[data-youtube-video]');
    const playButton = element.querySelector('[data-youtube-video-button]');
    const overlay = element.querySelector('[data-youtube-video-overlay]');
    const videoId = element.getAttribute('data-youtube-video-id');

    if (!player || !playButton || !overlay || !videoId) {
      throw new Error('Required elements or attributes not found');
    }

    this.player = player;
    this.playButton = playButton;
    this.overlay = overlay;
    this.videoId = videoId;
    this.playButton.addEventListener('click', () => this.play(), false);

    // Callback when api is loaded is only called once so we need to queue loading of all videos on the page
    // (Only a problem if more than one video is present)
    if (YoutubePlayer.apiIsLoaded) {
      this.loadYoutubePlayer(this.player, this.videoId);
    } else {
      if (!YoutubePlayer.callbackQueue) {
        YoutubePlayer.callbackQueue = new Array<{ (): void }>();
      }

      YoutubePlayer.callbackQueue.push(() => this.loadYoutubePlayer(this.player, this.videoId));
    }

    if (!document.querySelector(`script[src="${YoutubePlayer.apiUrl}"]`)) {
      YoutubePlayer.injectYoutubeApi();
    }
  }

  loadYoutubePlayer(player: Element, videoId: string) {
    // Initializes the actual video using youtubes api
    this.youtubePlayer = new (<any>window).YT.Player(player, {
      videoId,

      playerVars: { autoplay: 0, controls: 2, rel: 0, showinfo: 0, origin: location.origin },
      events: {},
    });
  }

  public play() {
    (<HTMLElement>this.overlay).style.display = 'none';
    this.youtubePlayer.playVideo();
    const iframe = <HTMLElement>document.querySelectorAll(`[data-youtube-video-id='${this.videoId}'] iframe`)[0];
    if (iframe) {
      iframe.removeAttribute('tabindex');
    }
  }

  static injectYoutubeApi() {
    // Load script
    const tag = document.createElement('script');
    tag.src = YoutubePlayer.apiUrl;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    // Assign the api loaded callback to our callback
    (<any>window).onYouTubeIframeAPIReady = () => YoutubePlayer.apiReadyCallback();
  }

  static apiReadyCallback() {
    if ((<any>window).YT) {
      YoutubePlayer.apiIsLoaded = true;
      // eslint-disable-next-line prefer-const
      for (let index in YoutubePlayer.callbackQueue) {
        YoutubePlayer.callbackQueue[index]();
      }
    }
  }
}

//
// InitializeComponents
const domComponents = document.querySelectorAll('[data-component="youtube-video"]');
for (let i = 0; i < domComponents.length; i += 1) {
  new YoutubePlayer(domComponents.item(i));
}
/* eslint-enable @typescript-eslint/no-explicit-any */

